import Vue from 'vue'
// import App from './App'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import '../../../common/css/reset.css'
import '../../../common/css/common.css'
import '../../../common/css/solve.css'
import '../../../common/font/iconfont.css'
import './education.css'

import hearMenu from 'components/hearMenu/hearMenu'
import footerMeta from 'components/footerMeta/footerMeta'

/* eslint-disable no-new */
Vue.use(MintUI);

import { pxToRem } from '../../../common/js/pxToRem.js'

new Vue({
	el: '#app',
	data:{
		addVertical:'',  //垂直居中
	},
	methods:{},
	mounted () {
		//检测是否是安卓机
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
		this.addVertical = isAndroid ? 'vertical-center' : '';
	},
	beforeCreate:function(){
		pxToRem();
	},
	created: function () {
	},
	components: {
		//在这里注册组件
		hearMenu,
		footerMeta
	}
})



// WEBPACK FOOTER //
// ./src/module/solve/education/education.js